module.exports = __webpack_public_path__ + "static/EnChartMobile-6a8668bb7b63f736825b3a093c114529.svg";